<template>
	<el-dialog title="补充物流信息" :visible.sync="dialogTableVisible">
        <el-table :data="gridData">
            <el-table-column property="conveyNumber" label="物流编号" width="150" align="center">
            </el-table-column>
            <el-table-column property="logisticsCompany" label="物流公司" width="180" align="center">
            </el-table-column>
            <el-table-column label="预计商品数量" width="130" align="center">
                <template slot-scope="scope">
                    <el-input-number v-model="scope.row.estimatedQuantity" controls-position="right" @change="handleChange(scope.row)" size="mini" :min="1" :max="1000"></el-input-number>
                </template>
            </el-table-column>
			<el-table-column property="receivedQuantity" label="到货商品数量" width="130" align="center">
            </el-table-column>
            <el-table-column property="createTime" label="创建时间" width="180" align="center">
            </el-table-column>
            
            <el-table-column label="操作" align="center" width="100">
				<template slot-scope="scope">
					<!-- <el-button
						type="primary"
						@click="updateLogistics(scope.row)"
						>编辑</el-button
					> -->
                    <el-button
						type="danger"
						@click="deleteLogistics(scope.row)"
						>删除</el-button
					>
				</template>
			</el-table-column>
        </el-table>

        <el-row class="padding">
			<el-button
				type="primary"
				@click="addLogistics"
				>新增</el-button
			>
		</el-row>

        <el-dialog
			width="54%"
			top="30vh"
			title="新增物流信息"
			:visible.sync="AddinnerVisible"
			append-to-body
		>
    

			<!-- <el-row>
				<el-col :span="50"> -->
					<el-row>
						<el-col class="padding" :span="8">
							<span class="leix">&nbsp;&nbsp;&nbsp;物流公司:&nbsp;&nbsp; </span>
							<el-select
								v-model="logisticsCompany"
								@change="SelectLogistics"
								value-key="id"
								filterable
								clearable
								placeholder="请选择"
								style="width: 63%;"
								class="logistics"
							>
								<el-option
									v-for="item in Logistics"
									:key="item.id"
									:label="item.logisticsCompanyName"
									:value="item"
								>
								</el-option>
							</el-select>
						</el-col>

						<el-col class="padding" :span="7">
							<el-input v-model.trim="internalConveyNumber" onkeyup="value=value.replace(/[^\x00-\xff]/g, '')">
								<template slot="prepend">
									运单号码:
								</template>
							</el-input>
						</el-col>

						<el-col class="padding" :span="5" :offset="0" style="margin-left: 35px;">
							<strong class="leix">商品数量：</strong>
							<el-input-number v-model="estimatedQuantity" size="small" :min="1" :step="1">
							</el-input-number>
						</el-col>
						
						
					</el-row>

				<!-- </el-col>
			</el-row> -->
           


            <div slot="footer" class="dialog-footer">
				<el-button
					type="primary"
					@click="insertLogistics"
					:loading="isLoading"
					>保存</el-button
				>
				<el-button @click="insertLogisticsCancel">取消</el-button>
			</div>
        </el-dialog>

    </el-dialog>
</template>

<script>
import { ajaxPost, Baseurl } from '../../../api/api/api'
export default {
	name: 'AlibabaLogisticsEdit',
	
	data() {
		return {
			gridData: [],
            dialogTableVisible: false,
            AddinnerVisible: false,
            Logistics: [],
            isLoading: false,
			logisticsCompany: '', //物流公司
			companyCode: '', //物流公司编码
			internalConveyNumber: '', //运单号码
			estimatedQuantity: 1,
			receivedQuantity: 1,
			isContent: '',
			str: '',
		}
	},
	mounted() {},


	methods: {
        insertLogistics() {
			if (
				!this.internalConveyNumber || !this.logisticsCompany
			) {
				this.$message.error('物流公司和运单号码必须同时填写')
			} else {
				this.AddAjax()
			}
        },
		AddAjax() {
			this.isLoading = true
			ajaxPost(
				Baseurl + 'additionalLogisticsInfoController/insertAdditionalLogistics', {
				alibabaOrderId: this.sondata,
				logisticsCompany: this.logisticsCompany,
				companyCode: this.companyCode,
				conveyNumber: this.internalConveyNumber,
				estimatedQuantity: this.estimatedQuantity,
				receivedQuantity: this.estimatedQuantity,
				roleId: this.str.rid,
			}).then((res) => {
				if (res.data.code == 200) {
					this.isLoading = false
					this.$message.success(res.data.data)
					this.logisticsCompany = ''
					this.internalConveyNumber = ''
					this.AddinnerVisible = false
					this.estimatedQuantity = 1
					this.receivedQuantity = 1
					this.getAdditionalLogistics()
				} else {
                    this.$message.error(res.data.data || res.data.message)
                }
			})
		},
        insertLogisticsCancel() {
			this.logisticsCompany = ''
			this.internalConveyNumber = ''
			this.estimatedQuantity = 1
			this.receivedQuantity = 1
			this.AddinnerVisible = false
        },
		SelectLogistics(val) {
			// console.log(val)
			this.logisticsCompany = val.logisticsCompanyName
			this.companyCode = val.logisticsCompanyCode
		},
        LogisticsAjax() {
			ajaxPost(
				Baseurl + 'logisticsController/getLogisticsCompanyList'
			).then((res) => {
				if (res.data.code == 200) {
					this.Logistics = res.data.data
				}
			})
		},
        addLogistics() {
            this.AddinnerVisible = true

        },
        deleteLogistics(row) {
            ajaxPost(
				Baseurl + 'additionalLogisticsInfoController/deleteAdditionalLogistics', {
				id: row.id,
			}).then((res) => {
				if (res.data.code == 200) {
					this.$message.success(res.data.data)
                    this.getAdditionalLogistics()
				} else {
                    this.$message.error(res.data.data || res.data.message)
                }
			})
        },
        handleChange(row) {
            // console.log(row);
            // 修改产品的数量
            ajaxPost(
				Baseurl + 'additionalLogisticsInfoController/updateAdditionalLogistics', {
				id: row.id,
				estimatedQuantity: row.estimatedQuantity,
				receivedQuantity: row.receivedQuantity,
			}).then((res) => {
				if (res.data.code == 200) {
					this.$message.success(res.data.data)
				} else {
                    this.$message.error(res.data.data || res.data.message)
                }
			})
        },
		init(e) {
            this.dialogTableVisible = true
			this.sondata = e
            this.getAdditionalLogistics()
            this.LogisticsAjax()
			this.str = JSON.parse(localStorage.getItem('role'))
		},
        getAdditionalLogistics() {
            ajaxPost(
				Baseurl + 'additionalLogisticsInfoController/selectAdditionalLogistics', {
				alibabaOrderId: this.sondata,
			}).then((res) => {
				if (res.data.code == 200) {
					this.gridData = res.data.data
				} else {
                    this.$message.error(res.data.data || res.data.message)
                }
			})
        }
		
	}
}
</script>

<style lang="scss" scoped>
    
    .padding {
        padding: 10px 0;
    }

	.leix {
		background-color: #f5f7fa;
		line-height: 30px;
		padding: 5px;
		border-left: 1px solid #e4e7ed;
		border-bottom: 1px solid #e4e7ed;
		border-top: 1px solid #e4e7ed;
		color: #909399;
		border-radius: 4px 0px 0px 4px;
		width: 100px;
	}
  
</style>
